/**
 * Returns array of objects in decending order based on a key value
 *
 * @param {Array} arr array of objects
 * @param {String} keyName name of key from objects
 * @return {Array} array of objects in decending order
 */

export default function (arr, keyName) {
  if (!arr) return null
  return arr.sort((a, b) => parseFloat(b[keyName]) - parseFloat(a[keyName]))
}
